<template>
    <v-container>
        <v-container class="pa-0 ls-add-status-alert">
            <v-alert
                v-model="alert.invoke"
                :type="alert.type"
                border="left"
                transition="slide-x-transition"
            >
                <v-row>
                    <v-col>
                        <span id="#ID_ADD_COMPANY_ALERT_TITLE" class="text-h5">
                            {{ alert.title }}
                        </span>
                        <v-divider class="mb-4" />
                        <span id="#ID_ADD_COMPANY_ALERT_MESSAGE">{{ alert.message }}</span>
                    </v-col>
                </v-row>
                <v-row v-if="alert.closeManually" class="justify-center">
                    <v-btn id="ID_ADD_COMPANY_ALERT_BUTTON_CLOSE" @click="closeAlert()">
                        Закрыть
                    </v-btn>
                </v-row>
            </v-alert>
        </v-container>

        <p id="#ID_TITLE_ADD_COMPANY" class="headline">Добавление новой компании</p>

        <v-container fluid>
            <v-form ref="form" v-model="isValid">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            id="#ID_ADD_COMPANY_NAME"
                            v-model="company.name"
                            :rules="[
                                (v) => !!v || 'Требуется ввести наименование компании',
                                (v) =>
                                    isCompanyAlreadyExists(v) ||
                                    'Компания с таким именeм уже существует',
                            ]"
                            label="Наименование компании"
                            required
                        ></v-text-field>

                        <v-text-field
                            id="#ID_ADD_COMPANY_DESCRIPTION"
                            v-model="company.description"
                            :rules="[(v) => !!v || 'Требуется ввести описание для компании']"
                            label="Описание компании"
                            required
                        ></v-text-field>

                        <v-switch
                            id="ID_ADD_COMPANY_READONLY"
                            v-model="company.readonly"
                            hide-details
                            :label="companyReadonlyLabel"
                        ></v-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6"></v-col>
                    <v-col class="d-flex justify-end mb-6" cols="12" sm="6">
                        <v-btn
                            id="ID_ADD_COMPANY_BUTTON_ADD"
                            :disabled="isAddButtonDisabled"
                            class="mr-2"
                            color="success"
                            @click.stop="clickOnAddCompanyButton()"
                        >
                            Добавить
                        </v-btn>

                        <v-btn
                            id="ID_ADD_COMPANY_BUTTON_CANCEL"
                            class="mr-2"
                            color="info"
                            @click="clickOnCancelButton()"
                        >
                            Отменить
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </v-container>
</template>

<script type="text/javascript">
    import CompaniesDataService from "../../services/CompaniesDataService";
    import { v4 as uuidv4 } from "uuid";

    export default {
        name: "company-add",
        data: () => ({
            usedCompaniesGuids: [],
            usedCompaniesNames: [],

            isValid: false,
            checkIsFormValidStateInterval: null,

            alert: {
                invoke: false,
                closeManually: false,
                type: "info", //v-alert type prop
                title: "",
                message: "",
            },
            company: {
                guid: "",
                name: "",
                description: "",
                readonly: false,
            },
            uniquePciPortForDevice: true,
            waitForResponse: false,
        }),
        created() {
            this.initData();
        },

        methods: {
            isCompanyAlreadyExists(serialNumber) {
                return !this.usedCompaniesNames.includes(serialNumber);
            },
            clickOnAddCompanyButton() {
                if (this.$refs.form.validate()) {
                    this.waitForResponse = true;
                    let data = {
                        guid: this.company.guid,
                        name: this.company.name,
                        description: this.company.description,
                        readonly: this.company.readonly,
                    };
                    console.info("Send create company with params:", data);
                    CompaniesDataService.create(data)
                        .then((response) => {
                            this.company.id = response.data.id;
                            this.setSuccessAlert(
                                "Добавление успешно выполнено",
                                "Компания " + this.company.name + " добавлена",
                            );
                            this.alert.invoke = true;
                            const closeTimeoutMs = 4000;
                            this.closeAlert(closeTimeoutMs);

                            this.initData();
                        })
                        .catch((e) => {
                            this.setErrorAlert("Не удалось добавить компанию", e);
                            this.alert.invoke = true;
                        });
                }
            },

            clickOnCancelButton() {
                this.$router.push("/companies");
            },

            initData() {
                this.getUsedFieldValues();
                this.clearData();
            },

            clearData() {
                this.$refs?.form?.reset();
                let companyUid = uuidv4();
                this.company.guid = companyUid;
                this.company.name = "";
                this.company.description = "";
                this.company.readonly = false;
            },

            /* Alerts */
            clearAlert() {
                this.alert.invoke = false;
                this.alert.closeManually = false;
                this.alert.title = "";
                this.alert.message = "";
            },

            setErrorAlert(title = "Ошибка", message = "") {
                this.alert.type = "error";
                this.alert.closeManually = true;
                this.alert.title = title;
                this.alert.message = message;
            },

            setSuccessAlert(title = "Успех", message = "") {
                this.alert.type = "success";
                this.alert.closeManually = false;
                this.alert.title = title;
                this.alert.message = message;
            },

            closeAlert(delay) {
                setTimeout(() => {
                    this.waitForResponse = false;
                    this.clearAlert();
                }, delay);
            },

            //Validation
            getUsedFieldValues() {
                this.usedCompaniesGuids = [];
                this.usedCompaniesNames = [];
                CompaniesDataService.getAll()
                    .then((response) => {
                        const companies = response.data;
                        console.info("Received companies is:", companies);
                        companies.forEach((item) => {
                            this.usedCompaniesGuids.push(item.guid);
                            this.usedCompaniesNames.push(item.name);
                        });
                    })
                    .catch((exception) => {
                        console.error(
                            "Error while receiving used field values. Reason: ",
                            exception.message,
                        );
                    });
            },

            isCompaniesGuidsAlreadyExists(guid) {
                return !this.usedCompaniesGuids.includes(guid);
            },
        },
        computed: {
            companyReadonlyLabel() {
                if (this.company.readonly) {
                    return "Тип взаимодействия: Только статистика";
                } else {
                    return "Тип взаимодействия: Полное управление";
                }
            },
            isAddButtonDisabled() {
                if (this.waitForResponse) return true;
                return !this.isValid;
            },
        },
        beforeCreate() {
            let client = this.$http.createClient();
            CompaniesDataService.setHttpClient(client);
        },
    };
</script>

